import React, { ReactElement, useCallback, useMemo } from 'react';

import { CustomDatePicker } from 'src/ui/components';

import { ResponseType } from 'src/features/PersonRepository/types/QuestionsTabType';
import { usePersonRepoStore } from 'src/features/PersonRepository/store/personRepoStore';
import { shouldDisableDate as canShowFutureDate } from 'src/utils/datepickerHelper';

export function DateEdit({
  question,
}: {
  question: ResponseType;
}): ReactElement {
  const qnTempId = useMemo(() => {
    return question?.TemplateId;
  }, [question]);

  const updateCalendarValue = usePersonRepoStore(
    useCallback(state => state.updateCalendar, []),
  );

  const calendarValue = usePersonRepoStore(
    React.useCallback(
      state =>
        question?.TemplateId &&
        state?.formValues?.Poc.Date &&
        state?.formValues?.Poc.Date[question?.TemplateId] &&
        state?.formValues?.Poc.Date[question?.TemplateId],
      [question?.TemplateId],
    ),
  );

  /*to check whether the dob type question comes with date type qn */
  function isDob() {
    const qnLabel = question?.FieldLabel?.toLowerCase();
    if (
      qnLabel?.includes('birthdate') ||
      qnLabel?.includes('dob') ||
      qnLabel?.includes('date of birth')
    )
      return true;
    else return false;
  }

  return (
    <dd className="flex gap-2  border-b dark:border-dark-medium">
      <h4 className="w-1/3 px-3 py-2 text-sm font-medium">
        {question?.FieldLabel}
      </h4>
      <p className="grid w-4/6 grid-cols-1 gap-x-6 gap-y-3 px-3 py-2 md:grid-cols-2">
        <CustomDatePicker
          id="date-birth"
          className="w-full"
          value={
            !calendarValue || calendarValue === 'null'
              ? null
              : new Date(calendarValue)
          }
          onChange={(e: any) => {
            if (!e) {
              qnTempId && updateCalendarValue(null, qnTempId);
              return;
            }
            if (isDob() && !canShowFutureDate(e))
              qnTempId && updateCalendarValue(e, qnTempId);
            else if (!isDob()) qnTempId && updateCalendarValue(e, qnTempId);
          }}
          // filterDate={(e: any) => {
          //   if (isDob() && canShowFutureDate(e)) return true;
          //   else return false;
          // }}
          hasMaxDate={isDob() ? false : true}
        />
      </p>
    </dd>
  );
}
